module.exports = __webpack_public_path__ + "img/monaco.43676bc1.png";